import { render } from "./CadastroPPG.vue?vue&type=template&id=8235c020&scoped=true"
import script from "./CadastroPPG.vue?vue&type=script&lang=js"
export * from "./CadastroPPG.vue?vue&type=script&lang=js"

import "./CadastroPPG.vue?vue&type=style&index=0&id=8235c020&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8235c020"]])

export default __exports__